import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { Context } from '../../utils/context';

function CheckoutPage() {
  // const [cartItems, setCartItems] = useState([]);
  const {setCartItems, cartItems,shippingAddress,setShippingAddress,paymentInfo,setPaymentInfo} = useContext(Context);


  useEffect(() => {
    // Fetch shipping address
    axios.get('http://localhost:1337/shipping-address')
      .then(response => {
        setShippingAddress(response.data);
      })
      .catch(error => {
        console.error('Error fetching shipping address:', error);
      });

    // Fetch payment information
    axios.get('http://localhost:1337/payment-info')
      .then(response => {
        setPaymentInfo(response.data);
      })
      .catch(error => {
        console.error('Error fetching payment information:', error);
      });
  }, []);

  return (
    <div>
      <h2>Checkout</h2>
      <h3>Cart Items</h3>
      <ul>
        {cartItems.map(item => (
          <li key={item.id}>
            {item.productName} - ${item.price}
          </li>
        ))}
      </ul>
      <h3>Shipping Address</h3>
      <p>Name: {shippingAddress.name}</p>
      <p>Address: {shippingAddress.address}</p>
      <p>City: {shippingAddress.city}</p>
      {/* Add more fields as needed */}
      <h3>Payment Information</h3>
      <p>Card Number: {paymentInfo.cardNumber}</p>
      <p>Expiry Date: {paymentInfo.expiryDate}</p>
      {/* Add more fields as needed */}
    </div>
  );
}

export default CheckoutPage;
